export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-50/40 via-background-50/20 to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-20">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span className="whitespace-nowrap">每日更新 · 免费阅读</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-900 leading-tight">
              女神漫画网
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-500 mt-1">
                免费全集在线下拉式阅读
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 mt-4 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              女神漫画网免费看平台，专注为漫画爱好者打造流畅的免费女神漫画在线下拉式阅读体验。
            </p>
            <p className="text-sm md:text-base text-foreground-400 mt-3 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              本站收录海量女神漫画免费全集，涵盖韩漫、日漫、国漫等热门题材，每日追更推荐不间断更新，
              支持手机端丝滑浏览，让您随时随地畅享好看的免费漫画大全。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-6 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-book-open-line text-primary-400"></i>
                <strong className="text-foreground-700">2000+</strong> 部漫画
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-timer-line text-primary-400"></i>
                <strong className="text-foreground-700">每日更新</strong> 追更
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-shield-check-line text-primary-400"></i>
                <strong className="text-foreground-700">免费安全</strong> 阅读
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                热门排行榜
              </a>
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-100 border border-background-300/60 text-foreground-700 rounded-full font-medium text-sm hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-star-line"></i>
                精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20manga%20comic%20illustration%20featuring%20stylized%20anime%20characters%20surrounded%20by%20floating%20comic%20pages%20and%20speech%20bubbles%2C%20warm%20coral%20pink%20and%20golden%20amber%20color%20palette%2C%20dynamic%20energy%20lines%2C%20Japanese%20manga%20aesthetic%2C%20playful%20atmosphere%2C%20cream%20background%20with%20subtle%20gradient%2C%20vector%20illustration%20style%2C%20high%20detail%2C%20professional%20quality&width=1200&height=900&seq=hero-manga-01&orientation=landscape"
                alt="女神漫画网 - 免费漫画在线阅读平台主视觉"
                title="女神漫画网免费全集在线下拉式阅读"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-12 lg:mt-10">
          <a
            href="#about"
            className="flex flex-col items-center gap-1 text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
          >
            <span className="text-xs whitespace-nowrap">向下探索</span>
            <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}